import { render, staticRenderFns } from "./Endorsements.vue?vue&type=template&id=d10ff710&"
import script from "./Endorsements.vue?vue&type=script&lang=js&"
export * from "./Endorsements.vue?vue&type=script&lang=js&"
import style0 from "./Endorsements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports